module.exports = __webpack_public_path__ + "static/media/installCloud.fbede669.svg";